import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
// import "element-ui/lib/theme-chalk/index.css";
import Vant from "vant";

import "vant/lib/index.css";
import "@/element-variables.scss";

Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.use(Vant);
store.commit("user/INIT");
store.commit("exhibition/INIT");
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

try {
  Vue.config.devtools = true;
} catch (e) {
  console.warn("Vue is not loaded yet");
}
